export function isSameDay(a, b) {
  return a.day === b.day
}
